import { useEffect, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// An iCerti order number (69540 / #69540) or expediente typed in the Planning
// search box may belong to another week: look it up globally and call
// onFound(appointment) so the Planning can jump to its date and open it.
// Exact match only (checked server-side).
export const useIcertiSearch = (searchQuery, onFound) => {
  const onFoundRef = useRef(onFound);
  onFoundRef.current = onFound;

  useEffect(() => {
    const q = searchQuery.trim();
    if (!/^#?\d{5,6}$/.test(q) && !/^(AS-\S+|IA\d+[A-Z]*)$/i.test(q)) return;
    const timer = setTimeout(async () => {
      try {
        const res = await axios.get(`${API}/icerti/find`, { params: { q } });
        const appt = (res.data.appointments || [])[0];
        if (appt) onFoundRef.current(appt);
      } catch {
        // search is a convenience; the local filter still works
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchQuery]);
};
